module.exports = __webpack_public_path__ + "img/icon-right-arrow.2fd0ef9f.svg";